import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedReplyFilterView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/reply/applied_reply_filter"]

  initialize: ->
    super
    @source = @options.source

  removeFilter: (value) ->
    @searchQuery.set(@getQuery(value), false)

  getQuery:(action) ->
    "#{action}_#{@source}_replies"